module.exports = __webpack_public_path__ + "img/pic_xifashui2.c01a3ea8.png";